import { useCallback } from 'react'
import { useSnack } from '@reapit/elements'
import { useIsSalesforceLiveChatAvailable, useStartSalesforceLiveChat } from '@reapit-sales/live-support-chat'
import { useCurrentUser, useCurrentOffice } from './utility'

import { NAVIGATION, trackMixpanelAction } from '../analytics'

export const handleLiveChatSupportClick = (legacyCRMIframePageName: string) => {
  // Get real user and office data from your application's context/hooks
  const currentUser = useCurrentUser()
  const currentOffice = useCurrentOffice()
  const { error } = useSnack()

  // Determine chat availability by passing in the actual data
  const isSalesforceLiveChatEnabled = useIsSalesforceLiveChatAvailable({
    currentUser,
    currentOffice,
  })

  const showLiveChatError = useCallback(
    (displayError: string) => {
      error(displayError)
    },
    [error],
  )

  // Get the chat initiation function, passing in the actual user and office data
  const initiateLiveChat = useStartSalesforceLiveChat({
    user: currentUser,
    office: currentOffice,
    callbacks: {
      // onSuccess: () => console.log('Live Chat window opened!'),
      onError: (err) => showLiveChatError(err),
      // onFinally: () => console.log('Chat launch process finished.'),
    },
  })

  const handleLiveChatClick = () => {
    if (isSalesforceLiveChatEnabled) {
      initiateLiveChat()
      // Track the Mixpanel event
      trackMixpanelAction(NAVIGATION.ACTION.NAVIGATE_START_SUPPORT_CHAT, {
        Script: NAVIGATION.SCRIPT_NAME.START_SUPPORT_CHAT,
        FromRoute: legacyCRMIframePageName,
      })
    }
  }

  return handleLiveChatClick
}
